import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

export default () => {
    const inertiaProps = usePage<IRhizomPageProps>();

    const hasSubsGodTrialAccess = computed(() => {
        // Admin users have access to all features regardless of subscription
        if (inertiaProps.props.isAdmin) {
            return true;
        }

        // Team must have scale plan or be trialing to access alerts
        if (
            inertiaProps.props.hasScalePlan ||
            inertiaProps.props.hasBasicPlan ||
            inertiaProps.props.isTrialing
        ) {
            return true;
        }

        return inertiaProps.props.hasGodMode;
    });

    return {
        hasSubsGodTrialAccess,
    };
};
